import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type EmailType as SchemaEmailType } from '../schemas/EmailType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const SetEmailContentType = 'application/json' as const;
export type SetEmailRequest = {
    email: string;
    password?: string;
    custom_domain: boolean;
    email_type: SchemaEmailType;
    alias?: string;
};
export type SetEmailResponses = LinkCommonErrorResponses & {
    '200': {};
};
export type SetEmailResponseSuccess = undefined;
export type SetEmailSearchParams = undefined;
export type SetEmailPathParameters = undefined;
export const SetEmailUrl = '/email/set' as const;
export const SetEmailMethod = 'POST' as const;
export const getSetEmailUrl = (_params?: SetEmailPathParameters) => SetEmailUrl;
